import {Http} from './index.js'
import {encodeQueryParams, buildUrlFilterParams} from '@/utils/api.js'

export default class Resource {
  get ({params = {limit: 100}, filterParams = {}} = {}) {
    const queryParams = [encodeQueryParams(params), buildUrlFilterParams(filterParams)].join('&')
    return Http.get(`${this.resource}/query?${queryParams}`)
  }
  getById (ids, {params = {limit: 100}, filterParams = {}} = {}) {
    const queryParams = [encodeQueryParams(params), buildUrlFilterParams(filterParams)].join('&')
    let idParam = ids
    if (Array.isArray(idParam)) {
      idParam = idParam.join(',')
    }
    const url = `${this.resource}/id/${idParam}/query?${queryParams}`
    return Http.get(url)
  }
  create (payload) {
    return Http.post(this.resource, payload)
  }
  patch (id, payload) {
    return Http.patch(`${this.resource}/id/${id}`, payload)
  }
  delete (id) {
    return Http.delete(`${this.resource}/id/${id}`)
  }
}
